import { baseApi } from "../baseApi";
import {
  GetCheckinByDateResponse,
  GetMonthlyAverageResponse,
  GetNextCheckinResponse,
  WellnessCheckinEntry,
  WellnessCheckinRequest,
  WellnessCheckinResponse,
} from "./type";

export const wellnessApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    submitWellnessCheckin: build.mutation<
      WellnessCheckinResponse,
      { id: string; data: WellnessCheckinRequest }
    >({
      query: ({ id, data }) => ({
        url: `/wellness/checkin/${id}`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["WellnessCheckins", "NextCheckin", "MonthlyAverage"],
    }),

    getWellnessCheckins: build.query<WellnessCheckinEntry, void>({
      query: () => ({
        url: "/wellness/checkins",
        method: "GET",
      }),
      providesTags: ["WellnessCheckins"],
    }),

    getNextCheckin: build.query<GetNextCheckinResponse, void>({
      query: () => ({
        url: "/wellness/checkins/next-checkin",
        method: "GET",
      }),
      providesTags: ["NextCheckin"],
    }),

    getMonthlyAverage: build.query<GetMonthlyAverageResponse, void>({
      query: () => ({
        url: "/wellness/checkins/weekly-average",
        method: "GET",
      }),
      providesTags: ["MonthlyAverage"],
    }),
    getWellnessCheckinsByDate: build.query<
      GetCheckinByDateResponse,
      { startDate: string; endDate: string; page?: number; limit?: number }
    >({
      query: ({ startDate, endDate, page = 1, limit = 10 }) => ({
        url: `/wellness/checkins`,
        method: "GET",
        params: {
          startDate,
          endDate,
          page,
          limit,
        },
      }),
      providesTags: ["WellnessCheckins"],
    }),
  }),
});

export const {
  useSubmitWellnessCheckinMutation,
  useGetWellnessCheckinsQuery,
  useGetNextCheckinQuery,
  useGetMonthlyAverageQuery,
  useGetWellnessCheckinsByDateQuery,
} = wellnessApi;
